import React from 'react';
import { Link } from 'react-router-dom';
import { isGiftFinderEnabled, giftFinderLinkLabel } from '../../giftFinder/giftFinderSettings';
import { getMergedStoreCopy } from '../../storeCopy';

export default function HomeAssistantCard({ site }) {
  const store = getMergedStoreCopy(site);
  if (!store.home_assistant_enabled) return null;
  if (!isGiftFinderEnabled(store)) return null;

  const title = store.home_assistant_title;
  const lead = store.home_assistant_lead;
  const button = store.home_assistant_button || giftFinderLinkLabel(store, 'home');

  return (
    <section className="home-assistant container my-3 my-lg-4">
      <div className="card border shadow-sm">
        <div className="card-body d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">
          <div className="flex-grow-1">
            <p className="small text-muted mb-1">{store.home_assistant_eyebrow}</p>
            <h2 className="h5 mb-1">{title}</h2>
            <p className="text-muted mb-0">{lead}</p>
          </div>
          <Link to="/gift-finder" className="btn btn-primary rounded-pill px-4 flex-shrink-0">
            {button}
          </Link>
        </div>
      </div>
    </section>
  );
}

